import styled, { keyframes } from 'styled-components';
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 100%;
`;
export const RowWrapper = styled.div`
  margin: -${({ theme }) => theme.spacing.x2};
  width: 100%;
`;
export const RowLevel = styled.div`
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-wrap: wrap;
    justify-content: start !important;
  }
`;
export const TextLevel = styled.span`
  font-size: 10px;
  font-weight: bold;
  color: #51b987;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    display: none;
  }
`;
const rotateslide = keyframes`   
   100% {
    -webkit-transform: rotate(360deg); 
        transform:rotate(360deg); 
    }
    `;
export const Dashed = styled.span`
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-color: #51b987;
    border-style: dashed;
    border-width: 3px;
    border-radius: 100px;
    padding: 4px;
    right: -6.5px;
    top: -6.5px;

    animation: ${rotateslide} 10s linear infinite;
  }
`;

export const ColTier = styled.div`
  width: 25%;
  padding: ${({ theme }) => theme.spacing.x2};
  display: flex;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: row;
    width: 33.333%;
    justify-content: space-evenly;
  }
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    width: 50%;
  }
`;
export const ProgressBarWrapper = styled.div`
  width: ${({ theme }) => theme.spacing.x26};
  height: ${({ theme }) => theme.spacing.x26};
  flex-shrink: 0;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    width: ${({ theme }) => theme.spacing.x13};
    height: ${({ theme }) => theme.spacing.x13};
  }
`;
export const WrapperText = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x1};
`;

export const LeftOver = styled.span`
  display: none;
  text-align: center;
  font-size: ${({ theme }) => theme.fs.xs};
  color: ${({ theme }) => theme.palette.lightText};
  direction: ltr;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-grow: 1;
    margin: 0 ${({ theme }) => theme.spacing.x2};
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const ProgressBarTitle = styled.span<{ $color: string }>`
  text-align: center;
  margin: ${({ theme }) => theme.spacing.x4} 0;
  font-size: ${({ theme }) => theme.fs.sm};
  font-weight: bold;
  letter-spacing: 2px;
  color: ${({ $color }) => $color};

  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-grow: 1;
    margin: 0 ${({ theme }) => theme.spacing.x2};
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
export const Percentage = styled.span`
  font-size: ${({ theme }) => theme.fs.lg};

  @media (max-width: ${({ theme }) => theme.media.sm}) {
    font-size: ${({ theme }) => theme.fs.sm};
  }
`;
export const Date = styled.span`
  font-size: ${({ theme }) => theme.fs.xxs};
  font-weight: 500;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    display: none;
  }
`;

export const ProgresBarText = styled.span`
  text-align: center;
  letter-spacing: 1px;
  margin-top: ${({ theme }) => theme.spacing.x10};
  font-weight: 300;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    margin-top: ${({ theme }) => theme.spacing.x5};
  }
`;

export const UserTierStatus = styled.p<{ $color: string }>`
  color: ${({ $color }) => $color};
`;

export const ParentBtnDahboard = styled.div`
  display: flex;
`;

export const Button = styled.button`
  font-size: ${({ theme }) => theme.fs.xs};
  margin: ${({ theme }) => theme.spacing.x5} 0 0;
  letter-spacing: 1px;
  text-align: center;
  display: block;
  margin-inline-start: ${({ theme }) => theme.spacing.x2};
`;
